var Qe = Object.defineProperty;
var Xe = (t, e, n) => e in t ? Qe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var ve = (t, e, n) => (Xe(t, typeof e != "symbol" ? e + "" : e, n), n), he = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var r = (t, e, n) => (he(t, e, "read from private field"), n ? n.call(t) : e.get(t)), u = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, A = (t, e, n, s) => (he(t, e, "write to private field"), s ? s.call(t, n) : e.set(t, n), n);
var o = (t, e, n) => (he(t, e, "access private method"), n);
const C = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), Z = Symbol("anyProducer"), Se = Promise.resolve(), N = Symbol("listenerAdded"), ee = Symbol("listenerRemoved");
let te = !1, fe = !1;
function K(t) {
  if (typeof t != "string" && typeof t != "symbol" && typeof t != "number")
    throw new TypeError("`eventName` must be a string, symbol, or number");
}
function J(t) {
  if (typeof t != "function")
    throw new TypeError("listener must be a function");
}
function k(t, e) {
  const n = E.get(t);
  if (n.has(e))
    return n.get(e);
}
function O(t, e) {
  const n = typeof e == "string" || typeof e == "symbol" || typeof e == "number" ? e : Z, s = M.get(t);
  if (s.has(n))
    return s.get(n);
}
function _e(t, e, n) {
  const s = M.get(t);
  if (s.has(e))
    for (const i of s.get(e))
      i.enqueue(n);
  if (s.has(Z)) {
    const i = Promise.all([e, n]);
    for (const a of s.get(Z))
      a.enqueue(i);
  }
}
function me(t, e) {
  e = Array.isArray(e) ? e : [e];
  let n = !1, s = () => {
  }, i = [];
  const a = {
    enqueue(c) {
      i.push(c), s();
    },
    finish() {
      n = !0, s();
    }
  };
  for (const c of e) {
    let l = O(t, c);
    l || (l = /* @__PURE__ */ new Set(), M.get(t).set(c, l)), l.add(a);
  }
  return {
    async next() {
      return i ? i.length === 0 ? n ? (i = void 0, this.next()) : (await new Promise((c) => {
        s = c;
      }), this.next()) : {
        done: !1,
        value: await i.shift()
      } : { done: !0 };
    },
    async return(c) {
      i = void 0;
      for (const l of e) {
        const w = O(t, l);
        w && (w.delete(a), w.size === 0 && M.get(t).delete(l));
      }
      return s(), arguments.length > 0 ? { done: !0, value: await c } : { done: !0 };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function Te(t) {
  if (t === void 0)
    return Ke;
  if (!Array.isArray(t))
    throw new TypeError("`methodNames` must be an array of strings");
  for (const e of t)
    if (!Ke.includes(e))
      throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  return t;
}
const P = (t) => t === N || t === ee;
function Q(t, e, n) {
  if (P(e))
    try {
      te = !0, t.emit(e, n);
    } finally {
      te = !1;
    }
}
class T {
  static mixin(e, n) {
    return n = Te(n), (s) => {
      if (typeof s != "function")
        throw new TypeError("`target` must be function");
      for (const c of n)
        if (s.prototype[c] !== void 0)
          throw new Error(`The property \`${c}\` already exists on \`target\``);
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new T()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const a = (c) => function(...l) {
        return this[e][c](...l);
      };
      for (const c of n)
        Object.defineProperty(s.prototype, c, {
          enumerable: !1,
          value: a(c)
        });
      return s;
    };
  }
  static get isDebugEnabled() {
    var n;
    if (typeof ((n = globalThis.process) == null ? void 0 : n.env) != "object")
      return fe;
    const { env: e } = globalThis.process ?? { env: {} };
    return e.DEBUG === "emittery" || e.DEBUG === "*" || fe;
  }
  static set isDebugEnabled(e) {
    fe = e;
  }
  constructor(e = {}) {
    C.set(this, /* @__PURE__ */ new Set()), E.set(this, /* @__PURE__ */ new Map()), M.set(this, /* @__PURE__ */ new Map()), M.get(this).set(Z, /* @__PURE__ */ new Set()), this.debug = e.debug ?? {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (n, s, i, a) => {
      try {
        a = JSON.stringify(a);
      } catch {
        a = `Object with the following keys failed to stringify: ${Object.keys(a).join(",")}`;
      }
      (typeof i == "symbol" || typeof i == "number") && (i = i.toString());
      const c = /* @__PURE__ */ new Date(), l = `${c.getHours()}:${c.getMinutes()}:${c.getSeconds()}.${c.getMilliseconds()}`;
      console.log(`[${l}][emittery:${n}][${s}] Event Name: ${i}
	data: ${a}`);
    });
  }
  logIfDebugEnabled(e, n, s) {
    (T.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, n, s);
  }
  on(e, n) {
    J(n), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      K(s);
      let i = k(this, s);
      i || (i = /* @__PURE__ */ new Set(), E.get(this).set(s, i)), i.add(n), this.logIfDebugEnabled("subscribe", s, void 0), P(s) || Q(this, N, { eventName: s, listener: n });
    }
    return this.off.bind(this, e, n);
  }
  off(e, n) {
    J(n), e = Array.isArray(e) ? e : [e];
    for (const s of e) {
      K(s);
      const i = k(this, s);
      i && (i.delete(n), i.size === 0 && E.get(this).delete(s)), this.logIfDebugEnabled("unsubscribe", s, void 0), P(s) || Q(this, ee, { eventName: s, listener: n });
    }
  }
  once(e) {
    let n;
    const s = new Promise((i) => {
      n = this.on(e, (a) => {
        n(), i(a);
      });
    });
    return s.off = n, s;
  }
  events(e) {
    e = Array.isArray(e) ? e : [e];
    for (const n of e)
      K(n);
    return me(this, e);
  }
  async emit(e, n) {
    if (K(e), P(e) && !te)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emit", e, n), _e(this, e, n);
    const s = k(this, e) ?? /* @__PURE__ */ new Set(), i = C.get(this), a = [...s], c = P(e) ? [] : [...i];
    await Se, await Promise.all([
      ...a.map(async (l) => {
        if (s.has(l))
          return l(n);
      }),
      ...c.map(async (l) => {
        if (i.has(l))
          return l(e, n);
      })
    ]);
  }
  async emitSerial(e, n) {
    if (K(e), P(e) && !te)
      throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
    this.logIfDebugEnabled("emitSerial", e, n);
    const s = k(this, e) ?? /* @__PURE__ */ new Set(), i = C.get(this), a = [...s], c = [...i];
    await Se;
    for (const l of a)
      s.has(l) && await l(n);
    for (const l of c)
      i.has(l) && await l(e, n);
  }
  onAny(e) {
    return J(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), C.get(this).add(e), Q(this, N, { listener: e }), this.offAny.bind(this, e);
  }
  anyEvent() {
    return me(this);
  }
  offAny(e) {
    J(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Q(this, ee, { listener: e }), C.get(this).delete(e);
  }
  clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (const n of e)
      if (this.logIfDebugEnabled("clear", n, void 0), typeof n == "string" || typeof n == "symbol" || typeof n == "number") {
        const s = k(this, n);
        s && s.clear();
        const i = O(this, n);
        if (i) {
          for (const a of i)
            a.finish();
          i.clear();
        }
      } else {
        C.get(this).clear();
        for (const [s, i] of E.get(this).entries())
          i.clear(), E.get(this).delete(s);
        for (const [s, i] of M.get(this).entries()) {
          for (const a of i)
            a.finish();
          i.clear(), M.get(this).delete(s);
        }
      }
  }
  listenerCount(e) {
    var s, i, a;
    e = Array.isArray(e) ? e : [e];
    let n = 0;
    for (const c of e) {
      if (typeof c == "string") {
        n += C.get(this).size + (((s = k(this, c)) == null ? void 0 : s.size) ?? 0) + (((i = O(this, c)) == null ? void 0 : i.size) ?? 0) + (((a = O(this)) == null ? void 0 : a.size) ?? 0);
        continue;
      }
      typeof c < "u" && K(c), n += C.get(this).size;
      for (const l of E.get(this).values())
        n += l.size;
      for (const l of M.get(this).values())
        n += l.size;
    }
    return n;
  }
  bindMethods(e, n) {
    if (typeof e != "object" || e === null)
      throw new TypeError("`target` must be an object");
    n = Te(n);
    for (const s of n) {
      if (e[s] !== void 0)
        throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  }
}
const Ke = Object.getOwnPropertyNames(T.prototype).filter((t) => t !== "constructor");
Object.defineProperty(T, "listenerAdded", {
  value: N,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(T, "listenerRemoved", {
  value: ee,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
function V(t) {
  return typeof t == "object" && t !== null;
}
function ke(t, e) {
  return e in t;
}
function h(t) {
  return V(t) && ke(t, "type");
}
function Ye(t) {
  return V(t) && typeof t.uuid == "string";
}
function Ze(t) {
  return V(t) && typeof t.ackedUuid == "string";
}
function Ne(t) {
  return V(t) && ke(t, "message");
}
function et(t) {
  return V(t) && typeof t.eventName == "string";
}
const tt = "activate";
function nt(t) {
  return h(t) && t.type === tt;
}
const st = "app";
function it(t) {
  return h(t) && t.type === st && "source" in t && "message" in t;
}
const ot = "app-ready";
function rt(t) {
  return h(t) && t.type === ot;
}
const ct = "close-side-panel";
function at(t) {
  return h(t) && t.type === ct;
}
const ut = "deactivate";
function lt(t) {
  return h(t) && t.type === ut;
}
const Pe = "dispatch-custom-event";
function ht(t) {
  return h(t) && t.type === Pe && et(t);
}
const ft = "do-not-disturb";
function dt(t) {
  return h(t) && (t == null ? void 0 : t.type) === ft;
}
const de = "health-check";
function Ie(t) {
  return h(t) && t.type === de;
}
const pt = "keyboard-command";
function yt(t) {
  return h(t) && t.type === pt && "code" in t;
}
const gt = "logout";
function bt(t) {
  return h(t) && t.type === gt;
}
const Mt = "module-ready";
function wt(t) {
  return h(t) && t.type === Mt && "module" in t;
}
const At = "navigate";
function Ct(t) {
  return h(t) && t.type === At;
}
const Et = "notification-clicked";
function xt(t) {
  return h(t) && t.type === Et;
}
const vt = "open-app";
function St(t) {
  return h(t) && t.type === vt && "name" in t;
}
const mt = "open-multi-login";
function Tt(t) {
  return h(t) && t.type === mt;
}
const Kt = "recreate";
function kt(t) {
  return h(t) && t.type === Kt;
}
const Pt = "refresh";
function It(t) {
  return h(t) && t.type === Pt;
}
const Bt = "settings-updated";
function Dt(t) {
  return h(t) && t.type === Bt && "newValue" in t;
}
const Ot = "show-native-app-install";
function Rt(t) {
  return h(t) && t.type === Ot;
}
const Lt = "show-notification";
function jt(t) {
  return h(t) && t.type === Lt && "title" in t && "body" in t && "icon" in t;
}
const Be = "ACK";
function De(t) {
  return h(t) && t.type === Be && Ze(t) && !!t.ackedUuid;
}
const Oe = "BRIDGE:ACTIVATED";
function $t(t) {
  return h(t) && t.type === Oe;
}
const Re = "BRIDGE:CONNECTED";
function Ht(t) {
  return h(t) && t.type === Re;
}
const Le = "HEARTBEAT";
function Ut(t) {
  return h(t) && t.type === Le;
}
function _(t) {
  return De(t) || Ut(t) || $t(t) || Ht(t);
}
const qt = "title-change";
function zt(t) {
  return h(t) && t.type === qt;
}
const Ft = "to-app";
function Gt(t) {
  return h(t) && t.type === Ft && "target" in t && "message" in t;
}
const Wt = "update-badge";
function Vt(t) {
  return h(t) && t.type === Wt && "value" in t;
}
function Jt(t) {
  if (!Ne(t.data) || !Ye(t.data) || t.data.uuid === "")
    return !1;
  const { message: e } = t.data;
  return _(e) || Ie(e) || nt(e) || lt(e) || Ct(e) || zt(e) || rt(e) || wt(e) || It(e) || Gt(e) || it(e) || Rt(e) || St(e) || Tt(e) || yt(e) || kt(e) || Vt(e) || at(e) || ht(e) || Dt(e) || jt(e) || xt(e) || bt(e) || dt(e);
}
const je = "KSUITE-BRIDGE:connection-establish";
function Qt(t) {
  var e;
  return (t == null ? void 0 : t.data) === je && ((e = t.ports) == null ? void 0 : e.length) > 0;
}
const $e = "KSUITE-BRIDGE:connection-request";
function Xt(t) {
  return (t == null ? void 0 : t.data) === $e;
}
const _t = 500, He = (t) => `ksuite-bridge-${t}`, Yt = (t) => {
  try {
    const e = localStorage.getItem(He(t));
    return e ? JSON.parse(e) : [];
  } catch {
    return [];
  }
}, Zt = (t, e) => {
  try {
    const n = e.slice(-_t);
    localStorage.setItem(He(t), JSON.stringify(n));
  } catch (n) {
    console.error("[LOGGER] Failed to save logs", n);
  }
}, Nt = ({
  prefix: t,
  payload: e,
  toConsole: n
}) => {
  const s = Yt(t), i = { timestamp: Date.now(), args: [...e] };
  s.push(i), Zt(t, s), n && console.log(...e);
};
function X() {
  let t = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const n = (t + Math.random() * 16) % 16 | 0;
    return t = Math.floor(t / 16), (e === "x" ? n : n & 3 | 8).toString(16);
  });
}
var R, I, Y, g, ne, Ue, se, qe, f, ie, ze, L, pe, oe, Fe, j, ye, B, v, S, D, $, ge, d, m, re, H, be, ce, Ge, U, Me, q, we, ae, We, z, Ae, F, Ce, G, Ee, ue, Ve, le, Je, b, x, p, y, W, xe;
class nn {
  constructor(e = { debug: !1 }) {
    u(this, I);
    /**
     * Starts the heartbeat interval to check channel health.
     * If a dead channel is found, it will be removed and a new channel will be requested.
     */
    u(this, ne);
    u(this, se);
    /**
     * Process postMessages if the bridge is not already connected.
     * @param messageEvent
     */
    u(this, ie);
    /**
     * Sends a ConnectionRequestMessage postMessage to the parent window to trigger unconnected host
     * bridge to send a ConnectionEstablishMessage.
     */
    u(this, L);
    /**
     * Respond to a ConnectionRequestMessage with a ConnectionEstablishMessage along with a channel
     * port.
     */
    u(this, oe);
    /**
     * Binds the given port to the bridge channel port, stops listening to post messages and starts
     * processing queued messages.
     * @param port
     */
    u(this, j);
    /**
     * Process the messages in `incomingMessageQueue` and `outgoingMessageQueue`. Process one message
     * by JS cycle to avoid clogging the thread.
     */
    u(this, $);
    /**
     * Sends the given wrapped message to all channels. If no channel is ready, the message is added
     * to the buffer for delayed processing. For non-system messages, each channel is "health checked"
     * before actually sending and dead channels are disconnected.
     */
    u(this, H);
    /**
     * Sends a `HeartbeatMessage` to a channel in `this.channelPorts` to see if it is still there.
     * `HeartbeatMessage` are processed only within the bridge so the timeout for the message to be
     * ack is set very low.
     */
    u(this, ce);
    /**
     * Sends a bridgeMessage to a channel in `this.channelPorts`. Sets a resolve callback in
     * `this.activeMessageResolvers` for this specific bridgeMessage or rejects after given
     * `messageTimeout` ms.
     *
     * `messageTimeout` defaults to `6_000`.
     */
    u(this, U);
    /**
     * Send a bridgeMessage to a specific channel.
     */
    u(this, q);
    /**
     * Process incoming channel messages if they are proper bridge messages.
     */
    u(this, ae);
    /**
     * Inject the the given message in the internal event bus or queue it if bridge not active.
     */
    u(this, z);
    /**
     * Acknowledge processing of message with a certain uuid
     */
    u(this, F);
    // *** Built in callbacks
    /**
     * Register all callbacks defined `builtInCallBack`. Does so without duplication by trying to
     * unsubscribing them before adding them.
     */
    u(this, G);
    /**
     * Health-check response process
     *
     * @param message {HealthCheckMessage}
     */
    u(this, ue);
    /**
     * Dispatch the event in given message to the document.
     *
     * @param message {DispatchCustomEventMessage}
     */
    u(this, le);
    // *** Debugging
    /**
     * Reserved for incoming and outgoing message activity. Skips health check to avoid polluting the console.
     */
    u(this, b);
    /**
     * Logs the given message if the bridge has debug mode enabled. Saves the log to local storage
     * to allow inspection (especially for client iframes via the host window's dev tools)
     */
    u(this, p);
    /**
     * Returns the message's key from a `BridgeMessage`, and the id of a channel port.
     */
    u(this, W);
    /**
     * Stops the bridge from listening to message events.
     */
    u(this, R, void 0);
    /**
     * Calculated name for the bridge
     */
    ve(this, "name");
    u(this, g, void 0);
    /**
     * The channel ports to which the bridge sends its messages.
     */
    u(this, f, /* @__PURE__ */ new Map());
    // *** Message queuing
    u(this, B, void 0);
    /**
     * An internal buffer to store outgoing message while the bridge is not active.
     */
    u(this, v, []);
    /**
     * An internal buffer to store incoming message while the bridge is not active.
     */
    u(this, S, []);
    u(this, D, !1);
    // *** Channel messages
    /**
     * The event bus exposing divers binding methods.
     */
    u(this, d, void 0);
    /**
     * The event bus for acknowledgement messages.
     */
    u(this, m, /* @__PURE__ */ new Map());
    /**
     * The callbacks we always want to have on our instance.
     */
    u(this, re, /* @__PURE__ */ new Map([
      [de, o(this, ue, Ve).bind(this)],
      [Pe, o(this, le, Je).bind(this)]
    ]));
    this.options = e;
    const n = this.options.debugPrefix || typeof this.options.debug == "string" && this.options.debug || Date.now().toFixed(0).slice(0, 8), s = this.options.iFrame ? "host" : "client";
    this.name = n.replace(/\s+/g, "") + "-" + s, A(this, d, new T({
      debug: {
        name: this.name,
        enabled: !!e.debugVerbose
      }
    })), A(this, B, this.options.activateOn ?? "connected");
    const i = o(this, ie, ze).bind(this);
    window.addEventListener("message", i), A(this, R, () => {
      window.removeEventListener("message", i);
    }), o(this, G, Ee).call(this), e.iFrame || o(this, L, pe).call(this), o(this, ne, Ue).call(this);
  }
  /**
   * Stops the bridge from listening to message events and removes the internal channelPort, making
   * the instance ready for garbage collection.
   */
  dispose() {
    r(this, R).call(this), r(this, g) && (clearInterval(r(this, g)), A(this, g, void 0));
    const e = r(this, f).values();
    let n;
    for (; !(n = e.next()).done; )
      o(this, I, Y).call(this, n.value);
    r(this, f).clear(), o(this, p, y).call(this, "🪦 Disposed");
  }
  // *** Connection
  /**
   * Whether the bridge has established a connexion with its counterpart.
   */
  get isConnected() {
    return this.channelPortsCount > 0;
  }
  /**
   * Number of open channel with the counterpart
   */
  get channelPortsCount() {
    return r(this, f).size;
  }
  /**
   * Whether the bridge has been enabled.
   */
  get isEnabled() {
    return r(this, D);
  }
  /**
   * Whether the bridge is connected _and_ enabled.
   */
  get isActive() {
    return this.isEnabled && this.isConnected;
  }
  /**
   * When using `'enabled'` activate strategy, marks the bridge as enabled. Has no effect in
   * `'connected'` strategy.
   */
  enable() {
    r(this, B) === "enabled" && (A(this, D, !0), o(this, $, ge).call(this));
  }
  /**
   * Sends a message to the bridge target. You can specify a custom timeout duration before the
   * methods throws if you know this message is expected to take a long time processing. By default,
   * the timeout will be `this.options.messageTimeout` or  `6_000`.
   */
  sendMessage(e, n = this.options.messageTimeout ?? 6e3) {
    const s = { uuid: X(), message: e };
    return o(this, H, be).call(this, s, n);
  }
  // *** Subscription
  /**
   * Subscribe to a given message type.
   */
  on(e, n) {
    return r(this, d).on(e, n);
  }
  /**
   * Unsubscribe a given callback by message type.
   */
  off(e, n) {
    r(this, d).off(e, n);
  }
  /**
   * Subscribe once to a given message type.
   */
  once(e) {
    return r(this, d).once(e);
  }
  /**
   * Subscribe to a buffered & ordered events iterator.
   */
  events(e) {
    return r(this, d).events(e);
  }
  /**
   * Unsubscribe all callbacks for a given type. If no type is provided, removes all callbacks from
   * all types.
   */
  allOff(e) {
    r(this, d).clearListeners(e), o(this, G, Ee).call(this);
  }
  /**
   * Get the registered callback number for a given type.
   * @param type
   */
  countListeners(e) {
    return r(this, d).listenerCount(e);
  }
}
R = new WeakMap(), I = new WeakSet(), Y = function(e) {
  e.onmessage = null, e.onmessageerror = null, e.close();
}, g = new WeakMap(), ne = new WeakSet(), Ue = function() {
  r(this, g) && clearInterval(r(this, g)), A(this, g, setInterval(() => {
    o(this, se, qe).call(this);
  }, this.options.heartbeatInterval ?? 2e3));
}, se = new WeakSet(), qe = function() {
  if (!this.isActive || r(this, f).size === 0)
    return;
  const e = Array.from(r(this, f).keys());
  for (const n of e)
    o(this, ce, Ge).call(this, n).catch(() => {
      o(this, p, y).call(this, "🪦 Channel is dead", n);
      const s = r(this, f).get(n);
      s && (o(this, I, Y).call(this, s), r(this, f).delete(n));
    });
}, f = new WeakMap(), ie = new WeakSet(), ze = function(e) {
  if (this.options.iFrame) {
    const n = !this.options.verifyIFrameSource || e.source === this.options.iFrame.contentWindow;
    Xt(e) && n && o(this, oe, Fe).call(this, this.options.iFrame);
  } else
    Qt(e) && !this.isConnected && o(this, j, ye).call(this, e.ports[0]);
}, L = new WeakSet(), pe = function() {
  window.parent.postMessage($e, "*"), o(this, p, y).call(this, "🤝 ConnectionRequestMessage sent");
}, oe = new WeakSet(), Fe = function(e) {
  const n = new MessageChannel();
  if (!e.contentWindow) {
    console.error("Content window is not accessible on given iframe");
    return;
  }
  o(this, j, ye).call(this, n.port1), e.contentWindow.postMessage(je, "*", [n.port2]), o(this, p, y).call(this, "🤝 ConnectionEstablishMessage sent");
}, j = new WeakSet(), ye = function(e) {
  const n = X();
  r(this, f).set(n, e), e.onmessage = o(this, ae, We).bind(this), e.onmessageerror = (s) => {
    console.error(
      `KSuiteBridge${typeof this.options.debug == "string" ? ` [${this.options.debug}]` : ""}: Message cannot be deserialized on channel ${n}`
    ), console.error(s.data);
  }, o(this, p, y).call(this, "🤝 Channel connected", n), o(this, p, y).call(this, "Active channels", Array.from(r(this, f).keys())), r(this, d).emit(Re, null), r(this, B) === "connected" && A(this, D, !0), o(this, $, ge).call(this);
}, B = new WeakMap(), v = new WeakMap(), S = new WeakMap(), D = new WeakMap(), $ = new WeakSet(), ge = async function() {
  if (!this.isActive)
    return;
  o(this, p, y).call(this, "⏩ Processing", r(this, S).length, "incoming and", r(this, v).length, "outgoing messages...");
  const e = [];
  for (; r(this, S).length > 0; )
    e.push(o(this, z, Ae).call(this, r(this, S).shift()));
  for (; r(this, v).length > 0; )
    e.push(o(this, H, be).call(this, r(this, v).shift()));
  await r(this, d).emit(Oe, null), await Promise.all(e);
}, d = new WeakMap(), m = new WeakMap(), re = new WeakMap(), H = new WeakSet(), be = async function(e, n = this.options.messageTimeout ?? 6e3) {
  const s = [];
  let i = !1;
  if (this.isActive) {
    const a = r(this, f).entries();
    let c;
    for (; !(c = a.next()).done; ) {
      const [l, w] = c.value;
      s.push(
        o(this, U, Me).call(this, e, l, w, n)
      );
    }
  } else
    _(e.message) || (o(this, b, x).call(this, e, "added to outgoing queue, bridge not active"), r(this, v).push(e), i = !0, s.push(
      new Promise((a) => {
        r(this, m).set(e.uuid, a);
      })
    ));
  return Promise.allSettled(s).then(() => {
    o(this, b, x).call(this, e, i ? "finally processed" : "processed by all channels");
  });
}, ce = new WeakSet(), Ge = function(e) {
  const n = r(this, f).get(e);
  if (!n)
    return Promise.reject(new Error(`Channel ${e} not found`));
  const s = {
    uuid: X(),
    message: { type: Le }
  };
  return o(this, U, Me).call(this, s, e, n, 500);
}, U = new WeakSet(), Me = function(e, n, s, i = 6e3) {
  return new Promise((a, c) => {
    const l = o(this, W, xe).call(this, e, n);
    o(this, q, we).call(this, e, n);
    const w = setTimeout(() => {
      o(this, b, x).call(this, e, "⌛ timeout to channel", n), o(this, I, Y).call(this, s), r(this, f).delete(n), this.options.iFrame || o(this, L, pe).call(this), c();
    }, i);
    r(this, m).set(l, () => {
      clearTimeout(w), a();
    });
  });
}, q = new WeakSet(), we = function(e, n) {
  var s;
  (s = r(this, f).get(n)) == null || s.postMessage({
    ...e,
    uuid: o(this, W, xe).call(this, e, n)
  }), _(e.message) || o(this, b, x).call(this, e, "sent to", n);
}, ae = new WeakSet(), We = async function(e) {
  if (Jt(e))
    return o(this, z, Ae).call(this, e.data);
}, z = new WeakSet(), Ae = async function(e) {
  var i, a;
  const { uuid: n, message: s } = e;
  if (De(s)) {
    const [c] = s.ackedUuid.split(":", 1);
    return (i = r(this, m).get(c)) == null || i(), (a = r(this, m).get(s.ackedUuid)) == null ? void 0 : a();
  }
  if (_(s))
    return o(this, F, Ce).call(this, n);
  if (o(this, b, x).call(this, e, "received"), !this.isActive) {
    o(this, b, x).call(this, e, "added to outgoing queue, bridge not active"), r(this, S).push(e);
    return;
  }
  await r(this, d).emit(s.type, s), o(this, F, Ce).call(this, n);
}, F = new WeakSet(), Ce = function(e) {
  const n = {
    uuid: X(),
    message: { type: Be, ackedUuid: e }
  }, s = r(this, f).keys();
  let i;
  for (; !(i = s.next()).done; )
    o(this, q, we).call(this, n, i.value);
}, G = new WeakSet(), Ee = function() {
  for (const [e, n] of r(this, re).entries()) {
    const s = n;
    this.off(e, s), this.on(e, s);
  }
}, ue = new WeakSet(), Ve = function(e) {
  e.status === "ping" && this.sendMessage({
    type: de,
    status: `pong from ${location.origin}`
  });
}, le = new WeakSet(), Je = function(e) {
  (e.selector === "window" ? window : document).dispatchEvent(
    new CustomEvent(e.eventName, { detail: e.payload })
  );
}, b = new WeakSet(), x = function(e, ...n) {
  var i;
  if (Ie(e.message))
    return;
  const s = [
    this.options.debugVerbose ? e : (i = e.message) == null ? void 0 : i.type,
    e.uuid
  ].filter(Boolean);
  o(this, p, y).call(this, "Message", ...s, ...n);
}, p = new WeakSet(), y = function(...e) {
  const n = [`%cKSuiteBridge%c[${this.name}]`, "color: #0098ff;", "color: #999;", ...e];
  Nt({ prefix: this.name, payload: n, toConsole: !!this.options.debug });
}, W = new WeakSet(), xe = function(e, n) {
  return `${e.uuid}:${n}`;
};
export {
  tt as ActivateMessageKey,
  st as AppMessageKey,
  ot as AppReadyMessageKey,
  Oe as BridgeActivated,
  Re as BridgeConnected,
  ct as CloseSidePanelMessageKey,
  je as ConnectionEstablishMessage,
  $e as ConnectionRequestMessage,
  ut as DeactivateMessageKey,
  Pe as DispatchCustomEventMessageKey,
  ft as DoNotDisturbMessageKey,
  de as HealthCheckMessageKey,
  nn as KSuiteBridge,
  pt as KeyboardCommandMessageKey,
  gt as LogoutMessageKey,
  Mt as ModuleReadyMessageKey,
  At as NavigateMessageKey,
  Et as NotificationClickedMessageKey,
  vt as OpenAppMessageKey,
  mt as OpenMultiLoginMessageKey,
  Kt as RecreateMessageKey,
  Pt as RefreshMessageKey,
  Bt as SettingsUpdatedMessageKey,
  Ot as ShowNativeAppInstallMessageKey,
  Lt as ShowNotificationMessageKey,
  qt as TitleChangeMessageKey,
  Ft as ToAppMessageKey,
  Wt as UpdateBadgeMessageKey,
  nt as isActivateMessage,
  it as isAppMessage,
  rt as isAppReadyMessage,
  Jt as isBridgeMessageEvent,
  at as isCloseSidePanelMessage,
  Qt as isConnectionEstablishMessage,
  Xt as isConnectionRequestMessage,
  lt as isDeactivateMessage,
  ht as isDispatchCustomEventMessage,
  dt as isDoNotDisturbMessage,
  Ie as isHealthCheckMessage,
  yt as isKeyboardCommandMessage,
  bt as isLogoutMessage,
  wt as isModuleReadyMessage,
  Ct as isNavigateMessage,
  xt as isNotificationClickedMessage,
  St as isOpenAppMessage,
  Tt as isOpenMultiLoginMessage,
  kt as isRecreateMessage,
  It as isRefreshMessage,
  Dt as isSettingsUpdatedMessage,
  Rt as isShowNativeAppInstallMessage,
  jt as isShowNotificationMessage,
  zt as isTitleChangeMessage,
  Gt as isToAppMessage,
  Vt as isUpdateBadgeMessage
};
